import './reportsPage.scss';

import { format } from 'date-fns';
import * as React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { setLoading, setSuccess } from '../../../actions/loadingActions';
import { years } from '../../../constants/generals';
import { IHistory } from '../../../interfaces';
import { ChecklistModel } from '../../../model/ChecklistModel';
import { QuestionModel, QuestionModelDuplicate } from '../../../model/QuestionModel';
import { getMonthlyChecklistData, getMonthlyFormQuestions } from '../../../services/monthlyFormService';
import { Async } from '../../reusableComponents/Async';
import { BasePage } from '../../reusableComponents/BasePage';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { Loader } from '../../reusableComponents/Loader';
import { SelectDropdown } from '../../reusableComponents/SelectDropdown';
import { prepareTable } from '../../../services/formService'; 
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { inspectionType } from '../../../constants/generals';

export interface IMonthlyChecklistReportProps {
    id: string;
    plantId: string;
    formType: string;
    history: IHistory;
    date: string;
    year: string;
    questions: QuestionModel[];
    questionsDuplicate: QuestionModel[];
    checkListInstance: ChecklistModel;
}

export interface IMonthlyChecklistReportState {
    date: Date;
    selectedYear: string;
    questions: {
        Question: string;
    }[];
    spccNewQuesSetStartFor2020: number;
}

export class MonthlyChecklistReportImpl extends React.Component<IMonthlyChecklistReportProps,
    IMonthlyChecklistReportState> {
    constructor(props: IMonthlyChecklistReportProps) {
        super(props);
        this.state = { date: new Date(props.date), questions: [], selectedYear: new Date().getFullYear().toString(), spccNewQuesSetStartFor2020: 7 };
    }

    promise = async () => {
        //await getMonthlyChecklistData(this.props.id, format(this.props.date.replace(/\-/g, '/'), 'YYYY'),
        await getMonthlyChecklistData(this.props.id, this.props.year,
            this.props.formType);
        const questions = await getMonthlyFormQuestions(this.props.formType, '', this.props.year); 
        this.setState({ questions });
    }

    filterList = async (year) => {
        const { formType, id, plantId, history: { push } } = this.props;
        setLoading('DailyChecklistData');  
        push(`/summary-reports/monthly/${formType}/${plantId}/${year}/${id}`);
        await getMonthlyChecklistData(id, year, formType);
        const questions = await getMonthlyFormQuestions(this.props.formType, '', this.props.year);
        this.setState({
            selectedYear: year, questions
        });
        setSuccess('DailyChecklistData');
    }

    getSummaryAnswer = (answerData) => {
        const { formType } = this.props; 
        const Tick = <i className="fa fa-check" aria-hidden="true"></i>;
        const Cross = <i className="fa fa-close"></i>;
        let answer = answerData.answer.answer;
        if (this.props.formType === 'MonthlySpillLogs__Test') { 
              return <OverlayTrigger placement="top" overlay={  <Tooltip id={`Tooltip - ${answerData.answer.quesNum} - ${answerData.answer.date}`}> <span>{ answerData.answer.quesNum === '61' && answer ? format(answer, 'MM/DD/YYYY') : answer}</span> </Tooltip>}>
              <span style={{ opacity: 1, fontSize: '15px', cursor:'default' }} >{answerData.answer.quesNum === '61' && answer ? format(answer, 'MM/DD/YYYY') : answer} </span>
          </OverlayTrigger>
        }
        if (answerData.answer.quesNum === '61') { 
           return <OverlayTrigger placement="top" overlay={  <Tooltip id={`Tooltip - ${answerData.answer.quesNum} - ${answerData.answer.date}`}> <span>{ answer ? format(answer, 'MM/DD/YYYY') : answer}</span> </Tooltip>}>
                <span style={{ opacity: 1, fontSize: '15px', cursor:'default' }} >{answer ? format(answer, 'MM/DD/YYYY') : answer} </span>
            </OverlayTrigger>
        }
        if (answerData.answer.quesNum === '62') {
            return <img width="95px" src={answer} />;
        } 
        return <OverlayTrigger placement="top" overlay={  <Tooltip id={`Tooltip - ${answerData.answer.quesNum} - ${answerData.answer.date}`}> <span>{ answer}</span> </Tooltip>}>
        <span style={{ opacity: 1, fontSize: '15px', cursor:'default' }} >{ answer ?
            (formType === 'MonthlyUSTRect' || formType === 'MonthlyUSTSpill' ?
                ( answer.length > 36 ? answer.substring(0, 35) + ".." : answer) : answer.length > 0 ? answer === 'Yes' ? Tick : (answer === 'No' ? Cross : ( answer.length > 36 ? answer.substring(0, 35) + ".." : answer) ) : '') : <span>A</span> }</span>
        </OverlayTrigger>  
    } 

    renderAnswers = () => {
        if (!this.props.checkListInstance) {
            return <span />;
        } 
        const { checkListInstance: { props: { answers } }, formType, year, questionsDuplicate } = this.props;    
        const questions = this.props.questions;    
        const dates = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let width = 100 / dates.length;
        if(formType=='MonthlySPCC' && year=='2020' ) {
           /*  let answer = [];
            let answer1: { answer: {
                date: string;
                flagged?: boolean;
                quesNum?: number;
                answer: string; }
            }[] = [];
            questionsDuplicate.forEach((que, index) => {
                answer.push({ answer: {answer: que.props.question, date: '', flagged: true, quesNum: 1} }); 
            });  */
            /* answer.push({ answer: {answer: null, date: '', flagged: true, quesNum: 1} }); */
            /* let item = { 
                data: [],
                entryDate: '',
                month: '0'
            }    */
            let item = {
                data: [{ 
                    answer: {
                        answer: '', date: '', flagged: true, quesNum: 1
                    }
                }],
                entryDate: '', 
                month: '0' 
            } 
            answers.length==12 && answers.splice(this.state.spccNewQuesSetStartFor2020, 0, item);  
            dates.length==12 && dates.splice(this.state.spccNewQuesSetStartFor2020, 0, 'New Ques'); 
            width = 87.02 / (dates.length - 1) ;
        }
        return <div className="answers" >
            {answers.map((data, index) => { 
                return formType!='MonthlySPCC' || year!='2020' || ( formType=='MonthlySPCC' && index!=this.state.spccNewQuesSetStartFor2020) ?
                 <div
                    key={index + 99}
                    style={{ display: 'inline-block', width: `${ width }%` }}
                    className="answer-row"
                >
                    {answers[index].data.map((answerData, index) => { 
                        if( (formType=='MonthlySPCC' ) && answerData.answer['quesNum'] =='29') {  //For omit time
                            return 
                        }
                        if( ( formType=='MonthlySpillLogs') && answerData.answer['quesNum'] =='5') { //For omit time
                            return 
                        }
                        return <h4
                            key={index}
                            className="answer-column"
                        >
                            {answerData.answer.answer ? this.getSummaryAnswer(answerData) : '' }
                        </h4>;
                    })}
                </div> : 
                <div className="questions-column" >
                    <div className="questions" >
                        {questionsDuplicate.map((que, index) => {
                            return <h4 key={index + 88}  >{ <OverlayTrigger placement="top" overlay={  <Tooltip id={`Tooltip - ${que.props.question} `}> <span>{ que.props.question }</span> </Tooltip>}>
                            <span style={{ opacity: 1,   cursor:'default' }} >{que.props.question.length > 100 ? que.props.question.substring(0, 100) + ".." :  que.props.question} </span>
                        </OverlayTrigger>}</h4>;
                        })}
                    </div>
                </div>
            })}
        </div>;
    }

    renderDates = () => {
        const { formType, year } = this.props;
        const answers = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];  
        if(formType=='MonthlySPCC' && year=='2020') {
            answers.length==12 && answers.splice(this.state.spccNewQuesSetStartFor2020, 0, 'New Ques');  
        }
        return <div className="dates" >
            {answers.map((que, index) => {
                let width = formType=='MonthlySPCC' && year=='2020' ?  index==this.state.spccNewQuesSetStartFor2020 ? '12.98' : 87.02 / (answers.length - 1) : 100 / answers.length 
                return <h4 key={index + 999} style={{ width: `${width}%` }}  >
                    {que!=='New Ques' && que || <span style={{marginTop: '11px'}}></span>}
                </h4>;
            })}
        </div>;
    }

    renderQuestions = () => {
        const questions = this.props.questions;  
        return <div className="questions" >
            {questions.map((que, index) => {
                return <h4 key={index + 88}  >{que.props.question}</h4>;
            })}
        </div>;
    }

    renderContent = () => {
        if (!this.props.checkListInstance) {
            return <span />;
        }
        const { checkListInstance: { props: { answers } } } = this.props;
        return <div>
            <div className="chart-title" id="chartTitle" >
                <SelectDropdown
                    onChange={this.filterList}
                    menuItems={years()}
                    defaultValue={format(this.props.date, 'YYYY')}
                />
                {/* <button className="download-button">Download As PDF</button> */}
            </div>
            <Async
                identifier="DailyChecklistData"
                promise={() => setSuccess('DailyChecklistData')}
                loader={<Loader type="async" />}
                content={
                    <div style={{ display: 'flex' }} >
                        <div className="dates-row" >{this.renderDates()}</div>
                        <PerfectScrollbar>
                            <div id="container" style={{ maxHeight: '84vh' }} >
                                <div className="questions-column" >{this.renderQuestions()}</div>
                                <div className="answers-data" >{this.renderAnswers()}</div>
                            </div>
                        </PerfectScrollbar>
                    </div>
                }
                error={<ErrorPage />}
            />
        </div>;
    }

    handlePrint = () => {
        const { checkListInstance, formType, year, questionsDuplicate } = this.props;
        let title = inspectionType(this.props.formType);
        this.state.questions.reverse();
        
        if(this.props.formType=='MonthlyUSTSpill') { 
            title ='UST Spill Container'; 
            if(this.state.questions.length==8) {
                this.state.questions.pop();
                this.state.questions.pop();
            } 
            if(checkListInstance.props.answers[0]['data'].length==8) {
                checkListInstance.props.answers.forEach((ins,index) => {
                    let entryDate = checkListInstance.props.answers[index]['entryDate'];
                    checkListInstance.props.answers[index]['data'][0]['answer']['answer'] =  entryDate===null?'':format(entryDate, 'MM/DD/YYYY');
                    checkListInstance.props.answers[index]['data'].splice(6, 2); 
                });
            }  
        }  
        let width = 50;
        if(formType=='MonthlySPCC' && year=='2020') {
            width = 45; 
            let answer = []; 
            questionsDuplicate.forEach((que, index) => {
                answer.push({ answer: {answer: que.props.question, date: '', flagged: true, quesNum: 1} }); 
            });  
            let timeData = {answer:{answer: 'Time', date: '', flagged: true, quesNum: 1} };
            answer.splice(28, 0, timeData);  
            let item = { 
                data: answer,
                entryDate: '',
                month: '0'
            }
            checkListInstance.props.answers[this.state.spccNewQuesSetStartFor2020] = item; 
        }
        prepareTable(checkListInstance,
            this.state.questions,
            `${title} 
            Reports for Plant ${this.props.plantId} (${(this.state.selectedYear)})`,
            width, 'Month');
    }

    render() {
        return <BasePage
            className="daily-checklist"
            pageTitle={`${inspectionType(this.props.formType )} Reports for
            ${format(this.props.date.replace(/\-/g, '/'), 'YYYY')} for Plant ${this.props.plantId}`}
            sideButton={
                <div key="details" onClick={this.handlePrint} className="button" id="print-button" style={{
                    position: 'absolute',
                    right: '10px',
                    width: 'fit-content',
                    paddingRight: '10px'
                }} >
                    <i className="fa fa-print" aria-hidden="true"></i>
                    &nbsp;
                    <span> Print</span>
                </div>
            }
        >
            <Async
                identifier="MonthlyChecklistReport"
                promise={this.promise}
                loader={<Loader type="async" />}
                content={this.renderContent()}
                error={<ErrorPage />}
            />
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    const formType = ownProps.match.params.formType;
    const checkListInstance = ChecklistModel.getBy('type', formType);
    const questions = QuestionModel.getAllByType(formType);
    let questionsDuplicate = [];
    if(formType=='MonthlySPCC') {
        questionsDuplicate = QuestionModelDuplicate.getAllByType('MonthlySPCC_OLD');
    }
    const date = ownProps.match.params.date
    return {
        checkListInstance,
        id: ownProps.match.params.id,
        plantId: ownProps.match.params.plantId,
        date,
        year: format(date.replace(/\-/g, '/'), 'YYYY'),
        formType,
        questions, questionsDuplicate
    };
}

export const MonthlyChecklistReport =
    withRouter(connect<{}, {}, IMonthlyChecklistReportProps>(mapStateToProps)(MonthlyChecklistReportImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Summary/ReportsPage/MonthlyChecklistReport.tsx